import React, { useCallback } from 'react';

const InputType = ({ label_text, label_no, eventListenTab, keyCount }) => {

    let prevKey = '';

    const handleKeyDown = (e) => {
        if ((prevKey !== 'Shift' && e.key === 'Tab') || e.key === 'Enter') {
            eventListenTab(e);
        } else if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 48 && e.keyCode <= 57)
            || (e.keyCode >= 186 && e.keyCode <= 190) || (e.keyCode >= 96 && e.keyCode <= 105)) keyCount();
        prevKey = e.key;
    }

    const handlePaste = (event) => {
        event.preventDefault()
    }

    const callbackRef = useCallback(inputElement => {
        if (inputElement && label_no === 1) {
            inputElement.focus();
        }
    }, []);

    return (
        <>
            {/* <td id={label_no} className="input-type" style={{ paddingTop: '0px' }}>
                <label style={{ position: 'relative', bottom: '-6px', fontSize: 'small' }}>{label_text} {label_no}</label>
                <input ref={callbackRef} id={`input-${label_no}`} type="text" maxLength={4} className='custom-form-input-tt28 px2' onKeyDown={handleKeyDown}
                    // <input ref={callbackRef} id='input-0' type="text" maxLength={4} className='custom-form-input-tt28 px2' onKeyDown={handleKeyDown}
                    style={{ border: '2px solid #1C304B', borderRadius: '7px', textAlign: 'left', width: '75px', height: '30px', fontSize: 'small' }} onPaste={(event) => handlePaste(event)}></input>
            </td> */}

            <div id={label_no}>
                <label className="caption" htmlFor={`input-${label_no}`}>
                    {label_text} {label_no}
                </label>
                <input id={`input-${label_no}`} ref={callbackRef} maxLength={4} className="num-txt-val pr0 custom-form-input-tt28" type="text" onKeyDown={handleKeyDown} onPaste={(event) => handlePaste(event)} />
            </div>
        </>);
};

export default InputType;